import { useState, useEffect } from "react";
import { EyeOff } from "lucide-react";
import QuestionInput from "./QuestionInput";
import { cn } from "@/lib/utils";

const ARRAY_TYPES = new Set([
  "multiple_choice",
  "multiple_dropdown",
  "attachment",
]);

const getInitialValue = (type) => (ARRAY_TYPES.has(type) ? [] : "");

const PreviewQuestionField = ({ question }) => {
  const [value, setValue] = useState(() =>
    getInitialValue(question?.questionType),
  );

  // Reset value when question changes (id or type)
  useEffect(() => {
    setValue(getInitialValue(question?.questionType));
  }, [question?._id, question?.questionType]);

  const isAttachment = question?.questionType === "attachment";

  return (
    <div className="space-y-2">
      {/* ── Preview notice (attachment only) ── */}
      {isAttachment && (
        <div
          className={cn(
            "flex items-start gap-2 rounded-lg border px-3 py-2.5",
            "bg-amber-50 border-amber-200",
            "dark:bg-amber-950/30 dark:border-amber-800",
          )}
        >
          <EyeOff className="h-3.5 w-3.5 mt-0.5 flex-shrink-0 text-amber-500" />
          <p className="text-xs text-amber-700 dark:text-amber-400 leading-snug">
            <span className="font-medium">Preview mode</span> — files are
            selected locally but will <span className="font-medium">not</span>{" "}
            be uploaded.
          </p>
        </div>
      )}

      <QuestionInput question={question} value={value} onChange={setValue} />
    </div>
  );
};

export default PreviewQuestionField;
